import { createSlice } from '@reduxjs/toolkit'

const createBeneficiaryModalState = createSlice({
  name: 'createBeneficiaryModalState',
  initialState: {
    open: false,
    data: {
      callback: () => {}
    },
    callback: () => {}
  },
  reducers: {
    setCreateBeneficiaryModalOpen: (state, action) => {
      state.open = action.payload
    },
    setCreateBeneficiaryModalData: (state, action) => {
      state.data = action.payload
    }
  }
})

export const { setCreateBeneficiaryModalOpen, setCreateBeneficiaryModalData } = createBeneficiaryModalState.actions

export default createBeneficiaryModalState.reducer